import { render } from "./NotifyProducts.vue?vue&type=template&id=b41e52d6"
import script from "./NotifyProducts.vue?vue&type=script&lang=js"
export * from "./NotifyProducts.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__